import { ConfigurationRelationshipStep } from '@/modules/configurationModule/shared/components/configuration-relationships-steps/configuration-relationships-steps.model'
import { ConfigurationAutomaticAssignmentAlgorithmStepEnumResponse } from '@/modules/configurationModule/detail/automation/personnel/algorithms-definition/services/configuration-automatic-assignment-algorithm-step-type/configuration-automatic-assignment-algorithm-step-type.dto'
import { ConfigurationAutomaticAssignmentAlgorithmStepResponse } from '@/modules/configurationModule/detail/automation/personnel/algorithms-definition/services/configuration-automatic-assignment-algorithm-step/configuration-automatic-assignment-algorithm-step.dto'
import { store } from '@/store/store'

export type ConfigurationAutomaticAssignmentAlgorithmStep = ConfigurationRelationshipStep<ConfigurationAutomaticAssignmentAlgorithmStepEnumResponse, ConfigurationAutomaticAssignmentAlgorithmStepResponse>

export interface ConfigurationAutomationPersonnelAlgorithmsDefinitionModalStepsFormState {
    automaticAssignmentAlgorithmStepTypes: ConfigurationAutomaticAssignmentAlgorithmStepEnumResponse[]
    automaticAssignmentAlgorithmSteps: ConfigurationAutomaticAssignmentAlgorithmStep[]
    laboratoryId: number
}
export const initialConfigurationAutomationPersonnelAlgorithmsDefinitionModalStepsFormState =
    (): ConfigurationAutomationPersonnelAlgorithmsDefinitionModalStepsFormState => ({
        automaticAssignmentAlgorithmStepTypes: [],
        automaticAssignmentAlgorithmSteps: [],
        laboratoryId: store.getters.labId
    })
